<template>
  <az-container>
    <div class="card-erro-container">
      <div class="mensagem-erro">
        <v-icon size="80">front_hand</v-icon>
        <h1>Erro 401</h1>
        <p>O seu usuário não tem acesso a esta página.</p>
      </div>
    </div>
  </az-container>
</template>

<script>
export default {
  name: 'NaoAutorizado'
}
</script>

<style scoped>
.card-erro-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 136px);
}
.mensagem-erro {
  text-align: center;
  color: #999;
  font-weight: bold;
}
</style>
